module.exports = __webpack_public_path__ + "img/vip-inn-miramonte-hotel.8b76455b.jpg";